define('modules/editor/behaviours/has_geometry',['require','exports','module','backbone'],function(require, exports, module) {

  var Backbone = require("backbone");

  module.exports = {
    setPosition: function(pos, options) {
      var geometry = this.getPropertyGroup(this.geometryProperty || "geometry");
      geometry.set(
        {
          top: parseInt(Math.max(pos.y, 0)),
          left: parseInt(Math.max(pos.x, 0))
        },
        options
      );
    },
    getPosition: function(){
      return {
        y: parseInt(this.getPropertyGroup(this.geometryProperty).get("top")),
        x: parseInt(this.getPropertyGroup(this.geometryProperty).get("left")),
      };
    },
    setSize: function(s, options){
      var geometry = this.getPropertyGroup(this.geometryProperty || "geometry"),
          w = geometry.get("width"),
          h = geometry.get("height");
      if (w !== s.width || h !== s.height) {
        geometry.set({
          width: parseInt(Math.max(s.width, 5)),
          height: parseInt(Math.max(s.height, 5))
        }, options);
      }
    },
    getSize: function(){
      var geometry = this.getPropertyGroup(this.geometryProperty || "geometry");
      return {
        width: parseInt(geometry.get("width")),
        height: parseInt(geometry.get("height"))
      };
    },
    mixed: function(klass) {
      var proto = klass.prototype;
      proto.initialize = _.wrap(proto.initialize || _.identity, function(init) {
        return init.apply(this, _.rest(arguments));
      });
    }
  };
});

